import SharedManagementAvailability from "views/Asesorias/components/ManagementAvailability/ManagementAvailability";
import { requestSwitchShiftOfSchedule } from "services/appointment/aboutAppoinment";

const ManagementAvailability = ({ dateTimeData, ...props }) => {
    const { date, hour, durationId } = dateTimeData;
    const normalizedDateTimeData = {
        ...dateTimeData,
        timeStart: hour * 60,
        timeEnd: (hour + 1) * 60
    };

    return (
        <SharedManagementAvailability
            {...props}
            dateTimeData={normalizedDateTimeData}
            slotLabel="hora"
            slotDemonstrative="esta"
            switchAvailability={({ activatedHour, inactivity }) =>
                requestSwitchShiftOfSchedule(activatedHour
                    ? { activate: { inactivityId: inactivity.id } }
                    : { inactivate: { durationId, date, timeStart: hour * 60 } })}/>
    );
};

export default ManagementAvailability;
